/* eslint-disable no-nested-ternary */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const Tab = ({
    children,
    isActive,
    onClick,
    activeStyle,
    tabStyle
}) => {

    const finalTabStyle = tabStyle ? tabStyle : "styles.tab";

    return (
        <div
            styleName={isActive ? (activeStyle ? `${activeStyle} ${finalTabStyle}` : `${finalTabStyle} active`) : finalTabStyle}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

Tab.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onClick: PropTypes.func,
    isActive: PropTypes.bool,
    activeStyle: PropTypes.string,
    tabStyle: PropTypes.string
};

export default Tab;
